import { styled } from '@linaria/react';

import SpinnerSvg from './images/spinner.svg';

export const Root = styled.div<{ size?: number }>`
  width: ${({ size }) => size || 16}px;
  aspect-ratio: 1;
  position: relative;
`;

// Продолжительность одного оборота.
const SPIN_DURATION = '1s';

export const StyledSpinner = styled(SpinnerSvg)`
  width: 100%;
  aspect-ratio: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  color: var(--link-color);
  animation-duration: ${SPIN_DURATION};
  animation-iteration-count: infinite;
  animation-name: spin;
  animation-timing-function: linear;
  transform-origin: 0 0;

  @keyframes spin {
    0% {
      transform: rotateZ(0) translate(-50%, -50%);
    }

    100% {
      transform: rotateZ(360deg) translate(-50%, -50%);
    }
  }
`;
